import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

const STORAGE_NAME = 'access_token';
export const useAccessTokenStore = defineStore('access_token', () => {
  const accessToken = ref(localStorage.getItem(STORAGE_NAME));

  const getAccessToken = computed(() => accessToken.value);
  const setAccessToken = (val: string) => {
    accessToken.value = val;
    localStorage.setItem(STORAGE_NAME, val);
  };

  const deleteAccessToken = () => {
    accessToken.value = null;
    localStorage.removeItem(STORAGE_NAME);
  };

  return { getAccessToken, setAccessToken, deleteAccessToken };
});
